<template>
  <ul class="-col-group" name="ListMS" style="display: inline-block; width: 220px">
    <div class="-col-group-title">
      <input
        type="checkbox"
        :checked="isAllSelected"
        @change="selectAll(isAllSelected)">
      <label class="MS-label">
        {{ groupName }}
      </label>
    </div>
    <li v-for="el in elements" style="display: flex;" :key="el.field">
      <input
        type="checkbox"
        :checked="el.isChecked"
        @change="handleChange(el, $event.target.checked)">
      <label class="MS-label">
        {{ el.title }}
      </label>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'ListMS',
  props: {
    groupName: { type: String, required: true },
    elements: { type: Array, required: true },
    globChanges: {type: Array, required: false},
    categories: Array,
    nChanges: Object
  },
  data: () => ({
    changes: [] // record the changes with a stack
  }),
  mounted () {
    this.getUnappliedChanges()
  },
  methods: {
    selectAll (isAllSelected) {
      var that = this
      if (isAllSelected) {
        that.elements.forEach(el => {
          el.isChecked = false
          that.changes.push({el, isChecked: false})
        })
      } else {
        that.elements.forEach(el => {
          el.isChecked = true
          that.changes.push({el, isChecked: true})
        })
      }
    },
    handleChange (el, isChecked) {
      el.isChecked = !el.isChecked
      this.changes.push({ el, isChecked })
    },
    uuidGen (key) {
      return `-col-${this._uid}-${key}`
    },
    async apply () {
      this.changes.forEach(({ el, isChecked }) => {
        this.$set(el, 'visible', isChecked)
      })
      if (this.nChanges) this.nChanges.shown_data += 1
      this.changes = [] // don't forget to clear the stack
    },
    test () {
      return this.isAllSelected
    },
    getUnappliedChanges () {
      for (var i = 0; i < this.elements.length; i++) {
        var el = this.elements[i]
        if (el.isChecked !== el.visible) {
          this.changes.push({el, isChecked: el.isChecked})
        }
      }
    }
  },
  computed: {
    isAllSelected () {
      return this.elements.every(function (el) {
        return el.isChecked
      })
    }
  },
  watch: {
    globChanges (gc) {
      gc.forEach(change => {
        this.changes.push(change)
      })
    }
  }
}
</script>
<style>
.-col-group {
  display: inline-block;
  margin-bottom: 5px;
  padding: 0;
  width: 300;
  vertical-align: top;
}
.-col-group-title {
  display: block;
  margin: 5px;
  padding: 5px;
  border-bottom: 1px solid #ddd;
  font-size: 18px;
}
.-col-group > li {
  margin-bottom: 5px;
  margin-right: 5px;
  padding-left: 10px;
  list-style: none;
  line-height: 20px;
  font-size: 12px;
}
.-col-group > li > * {
  margin: 0;
  vertical-align: middle;
}
.MS-label {
  color: #9A9A9A;
  font-size: 12px;
  font-weight: 500px;
  margin-left: 2px;
  text-transform: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Datatable/src/HeaderSettings/List_MultiSelect.vue